import {Dialog} from "./common";

export const action = "excel-export";

export class DialogBox extends Dialog{
	$show(box, form){
		this.view.$handleSelection = function(){
			return false;
		};

		form.elements.sheets.setValue(this.getSheets());
		form.elements.filename.setValue("Data");
		form.elements.filename.getInputNode().select();
	}
	$hide(){
		this.view.$handleSelection = null;
	}
	$init(){
		return {
			view: "ssheet-dialog",
			head: webix.i18n.spreadsheet.labels["export-title"],
			move: true,
			position: "center",
			body:{
				view:"form",
				elements:[
					{ view:"text", name:"filename",  placeholder:webix.i18n.spreadsheet.labels["export-name"]},
					{ view:"multicheckbox", name:"sheets"}
				]
			},
			on:{
				onSaveClick: () => okClick(this),
				onHideClick: () => this.close(),
				onCancelClick: () => this.close()
			}
		};
	}
	getSheets(){
		const view = this.view;
		const sheets = view._sheets;
		let value = [];

		for(let i = 0; i < sheets.length; i++)
			value.push({
				name: sheets[i].name,
				active: view._activeSheet === sheets[i].name ? 1 : 0
			});

		return value;
	}
}

function okClick(dialog){
	const values = dialog.$dialog.getBody().getValues();
	webix.toExcel(dialog.view, values);
	dialog.close();
}
